import { Heading } from '@react/chakra';
import { ArrowIcon } from '@react/chakra/core';

import type { JSX } from 'react';

import { Link, type ILinkProps } from '~/components/Link';

export interface IBackButtonProps extends ILinkProps {
  text: string;
}

export function BackButton({
  text,
  containerProps,
  ...props
}: IBackButtonProps): JSX.Element {
  return (
    <Link
      noUnderline
      containerProps={{
        ...containerProps,
        gap: 6,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
      }}
      {...props}
    >
      <ArrowIcon fill='white' w='25px' h='25px' transform='rotate(180deg)' />
      <Heading size='xl'>{text}</Heading>
    </Link>
  );
}
